<template>
  <ui-menu-base-trigger @focus="handleFocus">
    <template #default="{ openMenu }">
      <ui-button
        ref="buttonRef"
        secondary
        small
        :data-testid="dataTestid || 'menu-button-trigger'"
        :disabled="disabled"
        type="button"
        tabindex="0"
        :aria-expanded="expanded"
        @click="openMenu"
        @keydown.enter="openMenu"
      >
        <slot />
      </ui-button>
    </template>
  </ui-menu-base-trigger>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UiButton from '../../UiButton.vue'
import UiMenuBaseTrigger from './UiMenuBaseTrigger.vue'

defineProps<{
  disabled?: boolean
  expanded?: boolean
  dataTestid?: string
}>()

const buttonRef = ref<HTMLButtonElement | null>(null)

const handleFocus = () => {
  buttonRef.value?.focus()
}
</script>
